import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import arrow from '../../assets/newSvg/arrow-scroll.svg'

const Styles = styled.div`
    display: flex;
    align-items: center;
    margin-top: calc(var(--padding-top) + 1.5rem);
    margin-right: var(--padding);
    &.with-grid{
        position: absolute;
        top: 0;
        right:0;
    }
    &.glass-style{
        height: fit-content;
        color: var(--text-3);
        margin-top: 0;
        margin-left: var(--padding);
        width: calc(100% - calc(var(--width-padding) + 1rem));
        border-radius: 0 0 var(--border-radius-9) var(--border-radius-9) ;
        padding: 1rem 0.5rem;
        .svg-icon{
            fill: var(--text-3);
        }
        a{
            :hover{
                color: var(--text-4);
            }
        }
    }
    &.with-margin{
        margin-top: var(--top-gap);
    }
    &.without-margin{
        margin-top: 0;
        margin-right: 0;
    }
    &.without-margin-top{
        margin-top: 0;
    }
    a{
        text-decoration: none;
        color:  inherit;
        font-size: var(--fs-good-filt-arrow);
        :hover{
            color: var(--text-2);
        }
    }
    .bread-link{
        margin: 0 5px;
        font-size: var(--back-btn);
        font-weight: 300;
        
    }
    .svg-icon {
        width:  var(--back-btn);
        transform: rotate(180deg);
        fill: #484849;
    }
    @media screen and (max-width: 850px) {
        overflow: hidden;
        margin-top:var(--padding-top) ;
        &.glass-style{
            margin-top: 0rem;
        }
        &.with-margin{
            margin-top: var(--top-gap);
            /* padding:0.5rem ; */
        }
        .bread-link{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 20px;
        }
    }
`;



//show link where is the user step by step
class BreadCromb extends React.Component { 
    linkMaker = (data,index) => {
        if( data.diactive === false){
            return(
                <div key={index} className="bread-link">
                    {data.name}
                </div>
            )
        }else{
            let state = ''
            if(data.shopcode){
                state = {
                    shopcode : data.shopcode,
                    shopname : data.shopname
                }
            }
            return (
                <Link key={index} to={{pathname:data.link , state: state}} className="bread-link">
                    {data.name}
                </Link>
            )
        }
    }
    //last value must be a good name
    lastLink = (data,index) => {
        if(window.location.pathname.split('/')[1] === 'good'){
            return (
                <Link key={index} className="bread-link" to={data.link}>
                    {data.name}
                </Link>
            )
        }
        return (
            <div key={index} className="bread-link">
                {data.name}
            </div>
        )
    }
    // separation links
    makeLinks = () => {
        let bread = [];
        this.props.data.forEach((value, index) => {
            if(index < (this.props.data.length - 1)){
                bread.push(
                    this.linkMaker(value,index)
                )
                bread.push(
                    <img src={arrow} alt='arrow'  className="svg-icon"/>
                )
            } else {
                bread.push(
                    this.lastLink(value,index)
                )
            }
        });
        return bread
    }
    render() {
        return (
            <Styles className={this.props.classname} style={{color: this.props.color}} >
                {this.makeLinks()}
            </Styles>
        )
    }
}

export default BreadCromb;